import { render, staticRenderFns } from "./SafetyDetail.vue?vue&type=template&id=3ed8c153"
import script from "./SafetyDetail.vue?vue&type=script&lang=js"
export * from "./SafetyDetail.vue?vue&type=script&lang=js"
import style0 from "./SafetyDetail.vue?vue&type=style&index=0&id=3ed8c153&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports